// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Save: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
            <path
                fill="currentColor"
                d="M10.286.749H9.214a.648.648 0 0 0-.643.656.65.65 0 0 0 .643.656h1.072c.236 0 .428.196.428.438v7.74a.433.433 0 0 1-.428.438H1.714a.433.433 0 0 1-.428-.437V2.499c0-.242.192-.438.428-.438h1.072a.648.648 0 0 0 .643-.656.648.648 0 0 0-.643-.656H1.714C.767.749 0 1.534 0 2.499v7.74c0 .967.767 1.75 1.714 1.75h8.572c.947 0 1.714-.783 1.714-1.75V2.5c0-.965-.769-1.75-1.714-1.75ZM2.992 4.253c-.284.231-.276.623-.035.875L5.53 7.81a.682.682 0 0 0 .944 0l2.571-2.682a.602.602 0 0 0-.036-.874.658.658 0 0 0-.908.035L6.643 5.806V.619A.63.63 0 0 0 6 0a.63.63 0 0 0-.643.619v5.188l-1.456-1.52a.644.644 0 0 0-.472-.197.65.65 0 0 0-.437.163Z"
            />
        </svg>
    );
};

export default React.memo(Save);
